import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';

export const useLocalize = () => {
  const intl = useIntl();

  return (key, placeholders) => localize(intl, key, placeholders);
};

export const useInvertedLocalize = (invertedLookup) => {
  const intl = useIntl();

  return (defaultMessage, placeholders) => {
    const id = invertedLookup[defaultMessage];

    if (!id) {
      return defaultMessage;
    }

    return localize(intl, { id, defaultMessage }, placeholders);
  };
};

export const getTranslatedMessageUsingId = (
  id,
  defaultMessage,
  placeholders
) => {
  const intl = useIntl();

  return localize(intl, { id, defaultMessage }, placeholders);
};
